// src/components/ProductMetaTags.jsx
import { Helmet } from 'react-helmet-async';

const ProductMetaTags = ({ product }) => {
  if (!product) return null;

  const productName = product.name;

  const productDescription = product.description ? 
    product.description.substring(0, 160) + '...' : 
    'Découvrez ce produit sur StelonneMarket';

  const BASE_URL_BACKEND = 'https://stelonne-market.online/backend/public/storage';

  const productImage = product.images[0]?.image
    ? `${BASE_URL_BACKEND}/products/${product.images[0].image}` // On reconstruit le lien complet
    : 'https://stelonne-market.online/default-product.jpg';

  // const productImage = product.images[0]?.image || 
  //   'https://stelonne-market.online/default-product.jpg';

  const productPrice = product.price || 0;
  const productSlug = product.id;
  const productCategory = product.category?.name || 'Produit';

  return (
    <Helmet>
      {/* Titre de la page - TRÈS IMPORTANT */}
      <title>{productName} - {productCategory} | StelonneMarket</title>
      
      {/* Description meta - IMPORTANT */}
      <meta name="description" content={productDescription} />
      
      {/* Mots-clés */}
      <meta name="keywords" content={`${productName}, ${productCategory}, achat en ligne, prix ${productPrice}, StelonneMarket`} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={`https://stelonne-market.online/product/${productSlug}`} />
      
      {/* Open Graph (Facebook, LinkedIn) */}
      <meta property="og:title" content={`${productName} - StelonneMarket`} />
      <meta property="og:description" content={productDescription} />
      <meta property="og:image" content={productImage} />
      <meta property="og:url" content={`https://stelonne-market.online/product/${productSlug}`} />
      <meta property="og:type" content="product" />
      <meta property="og:site_name" content="StelonneMarket" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${productName} - StelonneMarket`} />
      <meta name="twitter:description" content={productDescription} />
      <meta name="twitter:image" content={productImage} />
      
      {/* Schema.org JSON-LD (Google Shopping) */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          "name": productName,
          "description": productDescription,
          "image": [productImage],
          "category": productCategory,
          "sku": `STEL-${product.id}`,
          "brand": {
            "@type": "Brand",
            "name": productName || "StelonneMarket"
          },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "Accueil",
              "item": `https://stelonne-market.online/`
            }, {
              "@type": "ListItem",
              "position": 2,
              "name": productCategory,
              "item": `https://stelonne-market.online/?category=${product.category?.id}` // On simule un lien de catégorie
              
            }]
          },
          "offers": {
            "@type": "Offer",
            "url": `https://stelonne-market.online/product/${productSlug}`,
            "priceCurrency": "XOF",
            "price": productPrice,
            "itemCondition": "https://schema.org/NewCondition", // AJOUT
            "priceValidUntil": new Date(Date.now() + 365 * 24 * 60 * 60 * 1000)
              .toISOString().split('T')[0],
            "availability": product.stock > 0 ? 
              "https://schema.org/InStock" : 
              "https://schema.org/OutOfStock",
            "seller": {
              "@type": "Organization",
              "name": "StelonneMarket"
            }
          },
          "aggregateRating": product.rating ? {
            "@type": "AggregateRating",
            "ratingValue": product.rating,
            "reviewCount": product.review_count || 1
          } : undefined
        })}
      </script>
    </Helmet>
  );
};

// j\'ai aussi remarque le fait que les produits prennent un peu trop de temps avant 
// de s\'afficher dans la liste des produits du site (dans le home). j\'ai l\'impression 
// que sest en partie du fait qu\'il ya deja un nombre consequent deja de produit et la requette
//  n'est pas bonne (approprier) !? ou bien d'ailleur !? ; j'aimerai que tu m'eclaire sur comment savoir pourquoi et comment les corriger cela !?? ; j'aimerai accelerer le processus de chargement et d'affichage de tous les produits du site (car ca ira jusqu'a plus de 5000 produits meme)

export default ProductMetaTags;